export const ClimateWatchUrls = {
  indicators: `https://www.climatewatchdata.org/api/v1/data/ndc_content/indicators`,
  categories: `https://www.climatewatchdata.org/api/v1/data/ndc_content/categories`,
  sectors: `https://www.climatewatchdata.org/api/v1/data/historical_emissions/sectors`,
  gases: `https://www.climatewatchdata.org/api/v1/data/historical_emissions/gases`,
};
